var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"icon":['fat', _vm.toggle ? 'down-left-and-up-right-to-center' : 'up-right-and-down-left-from-center'],"tooltip-label":_vm.$t('button.full_screen')},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }